const Announcement = () => {
  return (
    <div className="mb-2 hidden h-8 animate-pulse bg-sky-700 text-center font-medium text-white duration-1000 lg:flex lg:items-start lg:justify-center">
      <span className="flex h-full items-center">
        Super Deals! Free Shipping on Orders Over 599LE
      </span>
    </div>
  );
};

export default Announcement;
